import vmClient from 'app/services/vmClient';
import {
  Entity,
  EntityStringId,
  IEntity,
  IEntityType,
} from 'app/types/entity';
import { DateMarshaller } from 'app/constants/schemas/Date';
import { Country, CountryMarshaller } from 'app/constants/enums/Country';
import { MeetingBooking } from 'app/constants/schemas/MeetingBooking';
import { TeacherApplicationVideo } from 'app/constants/schemas/TeacherApplicationVideo';

export interface ITeacherApplication extends IEntity {
  attributes: {
    id: EntityStringId;
    country: Country;
    nationality: Country;
    firstName: string;
    middleName: string | null;
    lastName: string;
    city: string | null;
    browser: string | null;
    identificationImageUrl: string | null;
    createdAt: Date;
    submissionTime: Date | null;
    submitted: boolean;
    question1Tries: number;
    question2Tries: number;
    nativeQuestionTries: number;
  };
  associations: {
    meetingBooking: MeetingBooking | null;
    question1: TeacherApplicationVideo | null;
    question2: TeacherApplicationVideo | null;
    nativeQuestion: TeacherApplicationVideo | null;
  };
}

export type TeacherApplication = Entity<ITeacherApplication>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherApplication: IEntityType<ITeacherApplication> = vmClient.defineClass({
  typeName: 'TeacherApplication',
  version: 3,
  lockable: true,
  persisted: true,

  attributes: {
    country: {
      type: Country,
      marshaller: CountryMarshaller,
      notNull: true,
    },
    nationality: {
      type: Country,
      marshaller: CountryMarshaller,
      notNull: true,
    },
    firstName: {
      type: 'string',
      notNull: true,
    },
    lastName: {
      type: 'string',
      notNull: true,
    },
    middleName: 'string', // Only required for applicants in the Philippines
    city: 'string', // Only required for applicants in the Philippines
    browser: 'string',
    identificationImageUrl: 'string',
    submitted: 'boolean',
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    submissionTime: {
      type: Date,
      marshaller: DateMarshaller,
    },
    question1Tries: 'number',
    question2Tries: 'number',
    nativeQuestionTries: 'number',
  },
  associations: {
    meetingBooking: {
      type: MeetingBooking,
      shared: true,
    },
    question1: {
      type: TeacherApplicationVideo,
    },
    question2: {
      type: TeacherApplicationVideo,
    },
    nativeQuestion: {
      type: TeacherApplicationVideo,
    },
  },
});
